'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

require('./components/winresReservationPopup/winresReservationPopup');

require('./components/passengerFields/passengerFields');

require('./components/reservationErrors/reservationErrors');

require('./components/termsAccept/termsAccept');

require('./components/winresCarousel/winresCarousel');

require('./components/winresDepartures/winresDepartures');

require('./components/winresDeparturesSearch/winresDeparturesSearch');

require('./components/winresDeparturesList/winresDeparturesList');

require('./components/winresDestinationsFilter/winresDestinationsFilter');

require('./components/winresDeparturesView/winresDeparturesView');

require('./components/winresDeparture/winresDeparture');

require('./components/winresEventTicketWrapper/winresEventTicketWrapper');

require('./components/winresEventTickets/winresEventTickets');

require('./components/winresEventTicketModal/winresEventTicketModal');

require('./components/winresAsk/winresAsk');

require('./components/winresFault/winresFault');

require('./components/winresHead/winresHead');

require('./components/winresLogin/winresLogin');

require('./components/winresLogo/winresLogo');

require('./components/winresMenu/winresMenu');

require('./components/winresMessage/winresMessage');

require('./components/winresOmalomaAccommodations/winresOmalomaAccommodations');

require('./components/winresOmalomaAreaServicesPicker/winresOmalomaAreaServicesPicker');

require('./components/winresOmalomaCart/winresOmalomaCart');

require('./components/winresOmalomaBookingPicker/winresOmalomaBookingPicker');

require('./components/winresOmalomaCustomerEditor/winresOmalomaCustomerEditor');

require('./components/winresOmalomaDestinationInfo/winresOmalomaDestinationInfo');

require('./components/winresOmalomaBookingSummary/winresOmalomaBookingSummary');

require('./components/winresOmalomaContactForm/winresOmalomaContactForm');

require('./components/winresOmalomaExtraServices/winresOmalomaExtraServices');

require('./components/winresOmalomaExtraServicesPicker/winresOmalomaExtraServicesPicker');

require('./components/winresOmalomaExtraServicesBooked/winresOmalomaExtraServicesBooked');

require('./components/winresOmalomaLogin/winresOmalomaLogin');

require('./components/winresOmalomaPageHeader/winresOmalomaPageHeader');

require('./components/winresOmalomaPay/winresOmalomaPay');

require('./components/winresOmalomaPayAmountPicker/winresOmalomaPayAmountPicker');

require('./components/winresOmalomaPayMethodPicker/winresOmalomaPayMethodPicker');

require('./components/winresOmalomaPassengers/winresOmalomaPassengers');

require('./components/winresOmalomaRequestAccountRecovery/winresOmalomaRequestAccountRecovery');

require('./components/winresOmalomaRecoverAccount/winresOmalomaRecoverAccount');

require('./components/winresOmalomaMessages/winresOmalomaMessages');

require('./components/winresOmalomaDocuments/winresOmalomaDocuments');

require('./components/winresDeparturesCalendar/winresDeparturesCalendar');

require('./components/winresReservationCustomSelect/winresReservationCustomSelect');

require('./components/winresReservationCustomerInfo/winresReservationCustomerInfo');

require('./components/winresReservationPassengerInfo/winresReservationPassengerInfo');

require('./components/winresReservationTerms/winresReservationTerms');

require('./components/winresReservationCongressRooms/winresReservationCongressRooms');

require('./components/winresReservationExtraServices/winresReservationExtraServices');

require('./components/payButton/payButton');

require('./components/shoppingCartButton/shoppingCartButton');

require('./components/winresShareButton/winresShareButton');

require('./components/winresReservationCalendar/winresReservationCalendar');

require('./components/winresReservationShoppingTabsDeparture/winresReservationShoppingTabsDeparture');

require('./components/winresReservationPayButton/winresReservationPayButton');

require('./components/winresReservationShoppingTabs/winresReservationShoppingTabs');

require('./components/winresReservationCustomPhase/winresReservationCustomPhase');

require('./components/winresReservationShoppingTabsAccommodation/winresReservationShoppingTabsAccommodation');

require('./components/winresReservationShoppingTabsItem/winresReservationShoppingTabsItem');

require('./components/winresReservationShoppingTabsPassenger/winresReservationShoppingTabsPassenger');

require('./components/winresReservationSummary/winresReservationSummary');

require('./components/winresReservationButton/winresReservationButton');

require('./components/winresReservationPayment/winresReservationPayment');

require('./components/winresReservationPaymentMethod/winresReservationPaymentMethod');

require('./components/winresReservationConfirmation/winresReservationConfirmation');

require('./components/winresReservationMap/winresReservationMap');

require('./components/winresReservationHeader/winresReservationHeader');

require('./components/winresDestinationInfo/winresDestinationInfo');

require('./components/winresDestinationImages/winresDestinationImages');

require('./components/winresDestinationBlocks/winresDestinationBlocks');

require('./components/winresReservationNoOfPeople/winresReservationNoOfPeople');

require('./components/winresReservationTypes/winresReservationTypes');

require('./components/winresReservationTickets/winresReservationTickets');

require('./components/winresReservationTicketExtraServices/winresReservationTicketExtraServices');

require('./components/winresProductDistances/winresProductDistances');

require('./components/winresProductFeatures/winresProductFeatures');

require('./components/winresProductReview/winresProductReview');

require('./components/winresProductLine/winresProductLine');

require('./components/winresShoppingCart/winresShoppingCart');

require('./components/winresShoppingCartIndicator/winresShoppingCartIndicator');

require('./components/winresAccommodationPackage/winresAccommodationPackage');

require('./components/winresServices/winresServices');

require('./components/winresServicesWrapper/winresServicesWrapper');

require('./components/winresServiceInfo/winresServiceInfo');

require('./components/winresServiceReq/winresServiceReq');

require('./components/winresServiceSelectPassengers/winresServiceSelectPassengers');

require('./components/winresServiceGroupSelectPassengers/winresServiceGroupSelectPassengers');

require('./components/winresServiceSelectPrices/winresServiceSelectPrices');

require('./components/winresServiceGroupSelectPrices/winresServiceGroupSelectPrices');

require('./components/winresServiceSelectItems/winresServiceSelectItems');

require('./components/winresServiceSelectItem/winresServiceSelectItem');

require('./components/winresServiceSelectAmounts/winresServiceSelectAmounts');

require('./components/winresServiceSelectAmount/winresServiceSelectAmount');

require('./components/winresReservationTimeWrapper/winresReservationTimeWrapper');

require('./components/winresReservationTimeAmountSelect/winresReservationTimeAmountSelect');

require('./components/winresReservationTimeDurationSelect/winresReservationTimeDurationSelect');

require('./components/winresReservationTimeSlotSelect/winresReservationTimeSlotSelect');

require('./components/winresTransport/winresTransport');

require('./components/winresTransportWrapper/winresTransportWrapper');

require('./components/winresSchedule/winresSchedule');

require('./components/winresScheduleWeek/winresScheduleWeek');

require('./components/winresScheduleItem/winresScheduleItem');

require('./components/winresReservationExtraServicesWrapper/winresReservationExtraServicesWrapper');

require('./components/winresReservationExtraServicesGroup/winresReservationExtraServicesGroup');

require('./components/winresReservationExtraServicesCard/winresReservationExtraServicesCard');

require('./components/winresAreaDestinations/winresAreaDestinations');

require('./components/winresModal/winresModal');

require('./components/winresProductInfoFlyer/winresProductInfoFlyer');

require('./components/simpleModal/simpleModal');

require('./components/popupMessage/popupMessage');

require('./components/omalomaMenu/omalomaMenu');

require('./directives/responsive');

require('./directives/webComponent');

require('./controllers/omaloma');

require('./filters/searchFilter');

require('./components/winresShoppingCartModal/winresShoppingCartModal');

require('./components/winresNumOfPassengersSelect/winresNumOfPassengersSelect');

require('./components/winresAccommodationPackages/winresAccommodationPackages');

require('./components/winresDestination/winresDestination');

require('./components/winresDestinationProductSelect/winresDestinationProductSelect');

require('./components/winresKvBookingProcess/winresKvBookingProcess');

require('./components/winresDiscountCode/winresDiscountCode');

require('./components/winresSelectPaymentOption/winresSelectPaymentOption');

require('./components/winresAcceptTerms/winresAcceptTerms');

require('./components/winresMessageToBooking/winresMessageToBooking');

require('./components/winresGiftCards/winresGiftCards');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/index.js
// module id = 270
// module chunks = 2